import basePath from "base_path";
import ActionTypes, {WorkflowsActionTypes} from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";
import {WorkflowInstanceId} from "common/flowmaster/types/workflow";
import {DocumentId} from "common/types/document";
import {OrganisationId} from "common/types/organisation";
import {ProjectId} from "common/types/project";
import {DataAssetRunInfo} from "common/flowmaster/types/data_asset";

export type DataAssetRunAction = {
  type: WorkflowsActionTypes["DATA_ASSET_RUN"]["SUCCESS"];
  payload: Partial<DataAssetRunInfo>;
  action: (
    organisationId: OrganisationId,
    projectId: ProjectId,
    documentId: DocumentId,
    workflowInstanceId: WorkflowInstanceId,
    name: string,
    latestConfigId?: WorkflowInstanceId,
    materialiseWithLatestDependencies?: boolean,
  ) => Partial<DataAssetRunInfo>;
};

export default function runGenerateDataAsset(requestor) {
  return createReduxPromiseAction(
    ActionTypes.DATA_ASSET_RUN,
    (
      organisationId,
      projectId,
      documentId,
      workflowInstanceId,
      name,
      latestConfigId?,
      materialiseWithLatestDependencies = false,
    ) =>
      requestor
        .post(
          `${basePath}/organisation/${organisationId}` +
            `/project/${projectId}` +
            `/document/${documentId}` +
            `/workflow_instance/${workflowInstanceId}/asset`,
          {
            name,
            latest_config_id: latestConfigId,
            materialise_with_latest: materialiseWithLatestDependencies,
          },
          {withCredentials: true},
        )
        .then(response => response.data),
  );
}
